import { createFilterOptions } from '@mui/material/Autocomplete';
import type { FilterOptionsState } from '@mui/material/useAutocomplete';
import { AttributeOption } from '../../types/purchasing';

const baseAttributeFilter = createFilterOptions<AttributeOption>({
  stringify: (option) => `${option.code} ${option.number}`,
});

const normalizeSearchValue = (value: string) =>
  value.trim().toLocaleLowerCase('sv-SE').replace(/\s+/g, ' ');

const matchRank = (code: string, query: string) => {
  const normalizedCode = normalizeSearchValue(code);
  if (!query) return 0;
  if (normalizedCode === query) return 0;

  const dashParts = normalizedCode
    .split(/\s+-\s+/)
    .map((part) => part.trim())
    .filter(Boolean);
  if (dashParts.slice(1).some((part) => part === query)) return 1;
  if (normalizedCode.startsWith(query)) return 2;
  if (dashParts.some((part) => part.startsWith(query))) return 3;
  if (normalizedCode.includes(query)) return 4;
  return 5;
};

export const filterAttributeOptionsBySearchRank = (
  options: AttributeOption[],
  state: FilterOptionsState<AttributeOption>,
) => {
  const filtered = baseAttributeFilter(options, state);
  const query = normalizeSearchValue(state.inputValue);
  if (!query) return filtered;

  return filtered
    .map((option, index) => ({ option, index }))
    .sort((a, b) => {
      const rankDiff =
        matchRank(a.option.code, query) - matchRank(b.option.code, query);
      return rankDiff || a.index - b.index;
    })
    .map(({ option }) => option);
};
